
$(function () {
    $('[maxlength]').each(function () {

        const $self = $(this);

        updateCharactersRemaining($self);

        $self.on('keyup', function () {
            updateCharactersRemaining($self);
        });
    });

    $('#buttonChangeTimezone').on('click', function () {
        $('#timezoneMessage').hide();
        $('#timezoneSelector').show();
    });

    $('input[name="deliverywhen"]').on('change', function () {

        if ($('input[name="deliverywhen"]:checked').val() === 'specific') {
            $('#containerSpecificDeliveryDate').slideDown();
        } else {
            $('#containerSpecificDeliveryDate').slideUp();
        }
    });

    $('#checkboxNextDayDelivery').on('change', function () {

        const $self = $(this);
        const $selectorContainer = $('#containerSelectedDeliveryDate');
        const $hiddenSetter = $('#hiddenDeliveryTypeSetter');

        if ($self.is(':checked')) {
            $selectorContainer.slideUp();
            $hiddenSetter.val('nextday');
        } else {
            $selectorContainer.slideDown();
            $hiddenSetter.val('standard');
        }
    });

    $('[name="DeliveryDate"], [name="DeliveryHour"], [name="DeliveryMinute"]').on('change blur', function () {
        if ($('body').hasClass('byemail')) {
            validateDeliveryDateForByEmail();
        }
    });

    const $email = $('.email input[name="Email"]');
    const $emailConfirm = $('.email-confirm input[name="EmailConfirm"]');

    $email.on('keyup change', function () {
        if ($emailConfirm.is(':hidden')) {
            $emailConfirm.val($email.val());
        }
    });

    const $phoneNumberConfirmDiv = $('.phone-number-confirm');

    const $phone = $('.phone-number input[name="Telephone"]');
    const $phoneConfirm = $('.phone-number-confirm input[name="TelephoneConfirm"]');

    $phone.on('keyup change', function () {
        if ($phoneNumberConfirmDiv.is(':hidden')) {
            $phoneConfirm.val($phone.val());
        }
    });

    const $phoneCode = $('.phone-number select[name="TelephoneCallingCode"]');
    const $phoneCodeConfirm = $('.phone-number-confirm select[name="TelephoneConfirmCallingCode"]');

    $phoneCode.on('change', function () {
        if ($phoneNumberConfirmDiv.is(':hidden')) {
            $phoneCodeConfirm.val($(this).val());
        }
    });
});

function updateCharactersRemaining($input) {

    const maxLength = $input.attr('maxlength');

    const current = $input.val().length;
    const remaining = maxLength - current;

    const $message = $input.siblings('.characters-remaining').first();

    if ($message !== undefined && $message !== null) {

        $message.find('.count').text(remaining);

        if (remaining < 0) {
            $message.addClass('exceeded');
        } else {
            $message.removeClass('exceeded');
        }
    }
}

window.onloadMultiRecipientEGiftReadonly = function (isSendToSelfUrlDownload, isEdit) {

    // Disable the delivery variation buttons
    $('#btnMultiRecipientEGift_DownloadURLs').prop('disabled', true);
    $('#btnMultiRecipientEGift_SendToRecipients').prop('disabled', true);

    if (isSendToSelfUrlDownload) {
        onclickMultiRecipientEGift_DownloadURLs();
    } else {
        onclickMultiRecipientEGift_SendToRecipients();

        if (isEdit) {
            // It is assumed that items created via the multi-recipient XLS upload cannot be updated
            onclickMultiRecipientEGift_EnterManually();
        }
    }
}

window.onclickMultiRecipientEGift_UploadFile_Reset = function () {

    $('#containerMultiRecipientEGift_DeliveryVariations').show();
    $('#containerMultiRecipientEGift_Recipients').show();
    $('#containerMultiRecipientEGift_FileUploadResult').hide();
    $('#containerMultiRecipientEGift_ProceedToPayment').hide();

    $('#btnProceedToPayment, #btnProceedToPayment_AddAnother').prop('disabled', false);
    $('#btnMultiRecipientEGift_UploadFile').removeClass('current');
}

window.onclickMultiRecipientEGift_DownloadURLs = function () {

    // Hide the recipient option buttons, and the gift delivery section
    $('#containerMultiRecipientEGift_Recipients').hide();
    $('#containerMultiRecipientEGift_GiftDelivery').hide();

    // Show the gift value section and the submit buttons
    $('#containerMultiRecipientEGift_GiftValue').show();
    $('#containerMultiRecipientEGift_ProceedToPayment').show();

    // Highlight the "Download URLs" button as the current option
    $('#btnMultiRecipientEGift_DownloadURLs').addClass('current');

    // Un-highlight the other multi-recipient E-Gift options
    $('#btnMultiRecipientEGift_SendToRecipients').removeClass('current');
    $('#btnMultiRecipientEGift_EnterManually').removeClass('current');
    $('#btnMultiRecipientEGift_UploadFile').removeClass('current');

    toggleFlagsForMultiRecipientEGifts(true, false);
}

window.onclickMultiRecipientEGift_SendToRecipients = function () {

    if ($('#btnMultiRecipientEGift_SendToRecipients').hasClass('current')) {
        // If it's already the selected option there's no need to do nothing
        return;
    }

    // Hide the gift value section, gift delivery section, and the submit buttons
    $('#containerMultiRecipientEGift_GiftValue').hide();
    $('#containerMultiRecipientEGift_GiftDelivery').hide();
    $('#containerMultiRecipientEGift_ProceedToPayment').hide();

    // Show the recipient options buttons
    $('#containerMultiRecipientEGift_Recipients').show();

    // Highlight the "Send to Recipients" button as the current option
    $('#btnMultiRecipientEGift_SendToRecipients').addClass('current');

    // Un-highlight the other multi-recipient E-Gift options
    $('#btnMultiRecipientEGift_DownloadURLs').removeClass('current');
    $('#btnMultiRecipientEGift_EnterManually').removeClass('current');
    $('#btnMultiRecipientEGift_UploadFile').removeClass('current');

    toggleFlagsForMultiRecipientEGifts(false, false);
}

window.onclickMultiRecipientEGift_EnterManually = function () {

    // Show the gift value section, gift delivery section, and the submit buttons
    $('#containerMultiRecipientEGift_GiftValue').show();
    $('#containerMultiRecipientEGift_GiftDelivery').show();
    $('#containerMultiRecipientEGift_ProceedToPayment').show();

    // Highlight the "Enter Manually" button as the current option
    $('#btnMultiRecipientEGift_EnterManually').addClass('current');

    // Un-highlight the "Upload File" option
    $('#btnMultiRecipientEGift_UploadFile').removeClass('current');

    toggleFlagsForMultiRecipientEGifts(false, false);
}

window.onclickMultiRecipientEGift_UploadFile = function () {

    // Hide the gift value section, gift delivery section, and the submit buttons
    $('#containerMultiRecipientEGift_GiftValue').hide();
    $('#containerMultiRecipientEGift_GiftDelivery').hide();
    $('#containerMultiRecipientEGift_ProceedToPayment').hide();

    // Highlight the "Upload File" button as the current option
    $('#btnMultiRecipientEGift_UploadFile').addClass('current');

    // Un-highlight the "Enter Manually" option
    $('#btnMultiRecipientEGift_EnterManually').removeClass('current');

    toggleFlagsForMultiRecipientEGifts(false, true);
}

function toggleFlagsForMultiRecipientEGifts(isSendToSelfUrlDownload, isSendToRecipientsViaFileUpload) {
    $('#hiddenSendToSelfUrlDownload').val(isSendToSelfUrlDownload ? 'True' : 'False');
    $('#hiddenSendToRecipientsViaFileUpload').val(isSendToRecipientsViaFileUpload ? 'True' : 'False');

    if (isSendToSelfUrlDownload) {
        $('#Email').val('send.to.self@url.download');             // These "Email", "To", and "From" values are completely
        $('#EmailConfirm').val('send.to.self@url.download');      // arbitrary for URL download orders but need to be populated
        $('#To').val('SELF');                                     // with _something_ to pass both the client-side and
        $('#From').val('SELF');                                   // server-side validation as they're required fields
    } else if (isSendToRecipientsViaFileUpload) {
        $('#Email').val('send.to.recipients@file.upload');        // These "Email", "To", and "From" values will be set properly as
        $('#EmailConfirm').val('send.to.recipients@file.upload'); // part of the processing on page POST based on the values in the
        $('#To').val('FILE UPLOAD RECIPIENTS');                   // uploaded spreadsheet, but we need to put _something_ in them here
        $('#From').val('SELF');                                   // to get past the client-side validation as they're required fields
        $('#textboxGiftCardPriceX').val($('#textboxGiftCardPriceX').data('min-value'))
    } else if ($('#From').val() === '' || $('#From').val() === 'SELF') {
        $('#Email').val('');
        $('#EmailConfirm').val('');
        $('#To').val('');
        $('#From').val('N/A');
    }
}

window.onchangeMultiRecipientEGiftFile = function () {

    $('#inputMultiRecipientUploadConfirmation').prop('checked', false);

    if (window.FormData === undefined) {
        console.error('Unable to upload multi-recipient E-Gift file, FormData is not supported');
        return;
    }

    var $fileInput = $('#fileMultiRecipientEGift');

    if ($fileInput === undefined) {
        console.error('Unable to upload multi-recipient E-Gift file, input element does not exist');
        return;
    }

    var files = $fileInput[0].files;

    if (!files.length) {
        console.error('Unable to upload multi-recipient E-Gift file, no file selected');
        return;
    }

    $('#containerMultiRecipientEGift_UploadButtons').hide();
    $('#containerMultiRecipientEGift_UploadInProgress').show();

    $('#containerMultiRecipientEGift_ProceedToPayment').hide();
    $('#btnProceedToPayment, #btnProceedToPayment_AddAnother').prop('disabled', true);

    $('#containerMultiRecipientEGift_FileUploadResult [data-show-on-invalid]').hide();
    $('#containerMultiRecipientEGift_FileUploadResult [data-show-on-success]').hide();
    $('#containerMultiRecipientEGift_FileUploadResult [data-show-on-warning]').hide();

    var fileData = new FormData();
    fileData.append(files[0].name, files[0]);

    $.ajax({
        url: $fileInput.data('upload-url'),
        type: 'POST',
        contentType: false,
        processData: false,
        data: fileData,
        success: function (result) {
            if (result.Success) {
                console.info(result);
                $('#containerMultiRecipientEGift_DeliveryVariations').hide();
                $('#containerMultiRecipientEGift_Recipients').hide();

                if (result.IsValid) {
                    $('#containerMultiRecipientEGift_FileUploadResult').addClass('success');
                    $('#containerMultiRecipientEGift_FileUploadResult').removeClass('invalid');
                    $('#containerMultiRecipientEGift_FileUploadResult [data-show-on-success]').show();
                    $('#containerMultiRecipientEGift_ProceedToPayment').show();
                } else {
                    $('#containerMultiRecipientEGift_FileUploadResult').addClass('invalid');
                    $('#containerMultiRecipientEGift_FileUploadResult').removeClass('success');
                    $('#containerMultiRecipientEGift_FileUploadResult [data-show-on-invalid]').show();

                    $('#tableMultiRecipientEGift_FileUploadIssues tbody').html('');

                    $.each(result.AllValidationErrors, function (index, value) {
                        var rowHtml =
                            '<tr>' +
                            '<td>' + value.RowNumber + '</td>' +
                            '<td>' + value.Field + '</td>' +
                            '<td>' + value.Message + '</td>' +
                            '</tr>';

                        $('#tableMultiRecipientEGift_FileUploadIssues tbody').append(rowHtml);
                    });
                }

                if (result.HasWarnings) {
                    $('#containerMultiRecipientEGift_FileUploadResult [data-show-on-warning]').show();

                    $('#tableMultiRecipientEGift_FileUploadWarnings tbody').html('');

                    $.each(result.AllValidationWarnings, function (index, value) {
                        var rowHtml =
                            '<tr>' +
                            '<td>' + value.RowNumber + '</td>' +
                            '<td>' + value.Field + '</td>' +
                            '<td>' + value.Message + '</td>' +
                            '</tr>';

                        $('#tableMultiRecipientEGift_FileUploadWarnings tbody').append(rowHtml);
                    });
                }

                $('#containerMultiRecipientEGift_FileUploadResult [data-results-heading]').text(result.ResultHeading);
                $('#containerMultiRecipientEGift_FileUploadResult [data-results-message]').text(result.ResultMessage);

                $('#containerMultiRecipientEGift_FileUploadResult').show();
                $('button[data-dismiss="modal"]')[0].click();
            } else {
                console.error(result);
                $('#containerMultiRecipientEGift_UploadInProgress').hide();
                $('#containerMultiRecipientEGift_UploadButtons p.field-validation-error').remove();
                $('#containerMultiRecipientEGift_UploadButtons').append('<p class="field-validation-error">' + result.ErrorMessage + '</p>');
                $('#containerMultiRecipientEGift_UploadButtons').show();
            }
        },
        error: function (err) {
            console.error(err);
            $('#containerMultiRecipientEGift_UploadInProgress').hide();
            $('#containerMultiRecipientEGift_UploadButtons').show();
        },
        complete: function () {
            $fileInput.val('');
        }
    });

    $('#inputMultiRecipientUploadConfirmation').on('change', function () {
        if ($(this).is(':checked')) {
            $('#btnProceedToPayment, #btnProceedToPayment_AddAnother').prop('disabled', false);
        } else {
            $('#btnProceedToPayment, #btnProceedToPayment_AddAnother').prop('disabled', true);
        }
    });
}

window.validateDeliveryDateForByEmail = function () {

    var isValid = true;

    const specificDelivery = $('[name="deliverywhen"]:checked').val() === 'specific';

    if (specificDelivery) {


        if (deliveryDateIsUndefined()) {

            isValid = false;
            $('#deliveryDateValidation_Required').show();

        } else {

            $('#deliveryDateValidation_Required').hide();
        }

        if (deliveryDateIsInThePast()) {

            isValid = false;
            $('#deliveryDateValidation_IsPast').show();

        } else {

            $('#deliveryDateValidation_IsPast').hide();
        }
    }

    toggleDeliveryDateValidationClasses(isValid);

    return isValid;
}

function deliveryDateIsInThePast() {
    const deliveryDate = $('[name="DeliveryDate"]').val();
    const deliveryTimeHour = $('[name="DeliveryHour"]').val();
    const deliveryTimeMinute = $('[name="DeliveryMinute"]').val();

    const selected = Date.parse(deliveryDate + 'T' + deliveryTimeHour + ':' + deliveryTimeMinute + ':00');
    const current = Date.parse(new Date());

    if (selected < current) {
        return true;
    } else {
        return false;
    }
}

function deliveryDateIsUndefined() {
    const deliveryDate = $('[name="DeliveryDate"]').val();

    if (deliveryDate === undefined || deliveryDate === null || deliveryDate === '') {
        return true;
    } else {
        return false;
    }
}

function toggleDeliveryDateValidationClasses(isValid) {

    const selector =
        '[name="DeliveryDate"] + input-group,' +
        '[name="DeliveryDate"] + input-group input[type="text"],' +
        '[name="DeliveryHour"],' +
        '[name="DeliveryMinute"]';

    if (isValid) {
        $(selector).removeClass('is-invalid').addClass('is-valid');

    } else {
        $(selector).removeClass('is-valid').addClass('is-invalid');
    }
}
